export default __webpack_public_path__ + "static/media/z075di7a.e48ccac6.mp3";